// extracted by mini-css-extract-plugin
export default {"root":"ReturnOverlay_root__VUNk6","row":"ReturnOverlay_row__uHrqU"};